var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "parent",
      staticClass: "field flex align-center",
      class: [
        {
          "is-focused": _vm.isFocus,
          "has-value": _vm.value,
          "has-error": _vm.errorHint,
          "is-disabled": _vm.isDisabled,
          "is-dark": _vm.dark,
          "no-label": _vm.noLabel
        },
        _vm.inputSize
      ],
      on: { click: _vm.focusInput }
    },
    [
      _c(
        "b-input-group",
        { attrs: { size: _vm.inputSize } },
        [
          _c(
            "b-input",
            _vm._b(
              {
                ref: "CustomInput",
                class: { "no-clear-button": _vm.noClearButton },
                style: [_vm.borderStyle],
                attrs: {
                  id: _vm.$attrs.id,
                  size: _vm.inputSize,
                  value: _vm.value,
                  placeholder: _vm.$attrs.placeholder,
                  type: "text",
                  state: _vm.errorHint ? true : null,
                  disabled: _vm.disabled
                },
                on: {
                  focus: function($event) {
                    return _vm.$emit("focus")
                  },
                  blur: function($event) {
                    return _vm.$emit("blur")
                  },
                  click: function($event) {
                    return _vm.$emit("click")
                  }
                }
              },
              "b-input",
              _vm.$attrs,
              false
            )
          ),
          _vm._v(" "),
          _vm.hasClearButton
            ? _c(
                "b-input-group-append",
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "outline-input-special",
                      attrs: { size: _vm.inputSize, disabled: _vm.disabled },
                      on: {
                        click: function($event) {
                          return _vm.$emit("clear")
                        }
                      }
                    },
                    [_c("i", { staticClass: "far fa-backspace" })]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }